import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/salaExame`;

export default class SalaExameService{
	static async consultar() {
		return axios.get(URL_BASE + "/consultar");
	}
}



// WEBPACK FOOTER //
// ./src/service/SalaExameService.js